import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
  setDilisense(state, payload) {
    state.dilisense = payload;
  },
  setDocuments(state, payload) {
    state.documents = payload;
  },
  setQuestionnaire(state, payload) {
    state.questionnaire = payload;
  },
  setVideo(state, payload) {
    state.video = payload;
  },
};
